var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d76f6d0bde72f4411f5a08be9289a49e4a87cf8b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["legacy@interpals"]={id:"d76f6d0bde72f4411f5a08be9289a49e4a87cf8b"};
      